/*
  Fills the "More parts for this vehicle" section (sections/vehicle-parts.liquid).

  The product page renders an empty, hidden shell with a storefront search
  URL for the product's fitment tags. Once the shell is near the viewport,
  this fetches that search rendered through the same section file
  (section_id=vehicle-parts), drops the product being viewed, keeps the
  first few cards and reveals the section. If nothing is left, or the
  request fails, the section is removed, so the page never shows an empty
  heading.
*/
if (!customElements.get('vehicle-parts')) {
  customElements.define(
    'vehicle-parts',
    class VehicleParts extends HTMLElement {
      connectedCallback() {
        const observer = new IntersectionObserver(
          (entries, obs) => {
            if (!entries[0].isIntersecting) return;
            obs.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        // The shell is hidden, so watch its wrapper, which has a size.
        observer.observe(this.parentElement || this);
      }

      async load() {
        const url = `${this.dataset.url}&section_id=vehicle-parts`;
        const limit = parseInt(this.dataset.limit, 10) || 4;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.status);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');

          const cards = [...html.querySelectorAll('.vehicle-parts__results > li')]
            .filter((item) => item.dataset.productId !== this.dataset.productId)
            .slice(0, limit);

          if (!cards.length) return this.removeSection();

          this.querySelector('[data-vehicle-parts-grid]').append(...cards);
          this.hidden = false;
        } catch (error) {
          this.removeSection();
        }
      }

      removeSection() {
        (this.closest('.shopify-section') || this).remove();
      }
    }
  );
}
